// removed by extract-text-webpack-plugin
module.exports = {"form":"c-ConsentGroupForm__form"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/ConsentGroupForm/ConsentGroupForm.scss
// module id = 930
// module chunks = 0